// Global state composable
// Provides access to global store for miscellaneous global state including app context

import { useGlobalStore, APP_NAMES, type AppType } from '../stores/global.store'
import { isMobileOrTablet, isMobileOrTabletSSR } from '../utils/core.utils'

/**
 * Access global store state and actions
 * Includes app context, theme, language, and other global state
 */
export function useGlobal() {
  const globalStore = useGlobalStore()

  return {
    // App-related state
    appType: globalStore.appType,
    isClientportal: globalStore.isClientportal,
    isGokollab: globalStore.isGokollab,
    isMeet: globalStore.isMeet,
    isCourses: globalStore.isCourses,

    setAppType: globalStore.setAppType,
    isMobileOrTablet: function () {
      if (process.client) {
        return isMobileOrTablet() || window.innerWidth < 768
      }

      // Server-only compute
      const nuxtApp = useNuxtApp()
      return isMobileOrTabletSSR(nuxtApp)
    },

    // Future global state will be accessible here
    // theme: globalStore.theme,
    // language: globalStore.language,
    // isLoading: globalStore.isLoading,
    // notifications: globalStore.notifications,
  }
}

/**
 * Set app type (called during app initialization)
 * Convenience function for initialization
 */
export function setAppType(type: AppType) {
  const globalStore = useGlobalStore()
  globalStore.setAppType(type)
}

// Re-export constants for convenience
export { APP_NAMES, type AppType }
